import React from 'react';
import { useFormContext } from 'react-hook-form';
import classnames from 'classnames';

import RemixArrowDownLineSVG from '../../svg/icons/remix-arrow-down-line.svg';

import InputError from './Error';
import InputLabel from './Label';

const InputSelect = ({
  defaultValue,
  disabled = false,
  name,
  hidden = false,
  label,
  options,
  placeholder,
  required = false,
  validation = {},
}) => {
  const { errors, register } = useFormContext();

  const isRequired = required ? `${label} is required` : false;
  const isError = errors[name];

  const selectClass = classnames(
    'appearance-none bg-white border focus:bg-white focus:border-cornflower focus:outline-none py-2 px-3 rounded w-full',
    {
      'border-red-600': isError,
      'border-gray-300': !isError,
      'cursor-not-allowed opacity-50': disabled,
    }
  );

  const svgClass = classnames(
    'pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 ',
    {
      'text-gray-600': disabled,
      'text-cornflower': !disabled,
    }
  );

  return (
    <div className="flex flex-col mb-4">
      {label && !hidden && (
        <InputLabel
          label={required ? label : `${label} (optional)`}
          htmlFor={name}
        />
      )}
      <div className="relative">
        <select
          className={selectClass}
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          defaultValue={defaultValue || 'default'}
          ref={register({
            required: isRequired,
            ...(isRequired && {
              validate: (value) =>
                value !== 'default' || 'Please select an option',
            }),
            ...validation,
          })}
        >
          {!defaultValue && (
            <option disabled value="default">
              Select an option
            </option>
          )}
          {options.map(({ value, label }, index) => (
            <option value={value} key={index}>
              {label}
            </option>
          ))}
        </select>
        <div className={svgClass}>
          <RemixArrowDownLineSVG className="h-4 w-4" />
        </div>
      </div>
      {isError && <InputError>{errors?.[name]?.message}</InputError>}
    </div>
  );
};

export default InputSelect;
